import { useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { useSmoothNavigation, scrollToSection } from './useSmoothNavigation';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Products, ProductDialog } from './components/Products';
import { Assistances } from './components/Assistances';
import { LeadForm } from './components/LeadForm';
import { Footer, LegalDialog } from './components/Footer';
import './App.css';
import './Design.css';
import './Experience.css';
import './Hero.css';
import './Products.css';
import './AssistanceCatalog.css';

export default function App() {
  const [team, setTeam] = useState('empresa');
  const [interests, setInterests] = useState(['seguros-colaboradores']);
  const [product, setProduct] = useState(null);
  const [legal, setLegal] = useState(null);
  const [requestRevision, setRequestRevision] = useState(0);
  useSmoothNavigation(!!product || !!legal);
  const choose = (id) => {
    setInterests([id]); setProduct(null); setRequestRevision(value => value + 1);
    setTimeout(() => scrollToSection('asesoria', true), 230);
  };
  const browseCatalog = () => { setProduct(null); setTimeout(() => scrollToSection('asistencias'), 230); };
  return <MotionConfig reducedMotion="user"><a href="#main-content" className="skip-link" data-testid="skip-to-content">Saltar al contenido</a><Navbar /><main id="main-content"><Hero /><Products onOpen={setProduct} onChoose={choose} onBrowse={browseCatalog} /><Assistances /><LeadForm team={team} setTeam={setTeam} interests={interests} setInterests={setInterests} requestRevision={requestRevision} onPrivacy={() => setLegal('privacy')} /></main><Footer onLegal={setLegal} /><ProductDialog product={product} onClose={() => setProduct(null)} onChoose={choose} onBrowse={browseCatalog} /><LegalDialog type={legal} onClose={() => setLegal(null)} /><Toaster position="bottom-right" richColors closeButton /></MotionConfig>;
}